import { Link, useHistory } from "react-router-dom";
import { faPlus, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormEvent, useState } from "react";
import { ReaderPromo } from "./types";
import { useEffect } from "react";
import { fetchReaderPromos } from "./service";
import Intro from './Intro';
import { formatDateTime } from "../dates/helper";

export function Index() {

    const [searchText, setSearchText] = useState('');
    const [loading, setLoading] = useState(false);
    const [readerPromos, setReaderPromos] = useState<ReaderPromo[]>([]);
    const history = useHistory();

    useEffect(() => {
        loadReaderPromos();
    }, []);

    function handleSearchSubmit(event: FormEvent) {
        event.preventDefault();
        loadReaderPromos();
    }

    function loadReaderPromos() {
        const params = {
            search: searchText,
        };
        setLoading(true);
        fetchReaderPromos(params).then(({ data }) => {
            setReaderPromos(data);
            setLoading(false);
        });
    }

    return (
        <div>
            <div>
                <h1 className="text-lg">Reader Promotions</h1>
                <Intro/>
            </div>
            <div className="p-2 my-4 bg-white rounded shadow">
                <div className="flex items-center">
                    <form action="" onSubmit={handleSearchSubmit} className="flex">
                        <div className="mr-2">
                            <input type="search" placeholder="Search..." value={searchText} onChange={(e) => { setSearchText(e.target.value) }} className="mb-0 input-control" />
                        </div>
                        <div>
                            <button className="bg-yellow-300 button" disabled={loading}>Search</button>
                        </div>
                    </form>
                    <div className="flex h-auto ml-auto">
                        <button className="mr-2 text-white bg-gray-600 button" type="button" onClick={(event) => { event.preventDefault(); loadReaderPromos(); }} disabled={loading}>
                            <FontAwesomeIcon icon={faSyncAlt} className={'mr-1 text-sm ' + (loading ? 'fa-spin' : '')} />
                            {loading ? 'Loading...' : 'Refresh'}
                        </button>
                        <Link to="/readerPromos/new" className="bg-yellow-300 button">
                            <FontAwesomeIcon icon={faPlus} className="mr-1" />
                            <span>New Reader Promotion</span>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="p-2 my-4 bg-white rounded shadow">
                {readerPromos.length && !loading ? (
                    <table className="table w-full table-striped">
                        <thead>
                            <th className="text-left">Title</th>
                            <th className="text-left">Start Date</th>
                            <th className="text-left">End Date</th>
                        </thead>
                        <tbody>
                            {readerPromos.map((readerpromo) => (
                                <tr className="cursor-pointer" onClick={() => { history.push('/readerPromos/' + readerpromo.id + '/edit') }}>
                                    <td>{readerpromo.title}</td>
                                    <td>{formatDateTime(readerpromo.startDate)}</td>
                                    <td>{formatDateTime(readerpromo.endDate)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : null}
                {!readerPromos.length && !loading ? (
                    <p>No reader promotions found</p>
                ) : null}
                {loading ? (
                    <p>Loading reader promotions...</p>
                ) : null}
            </div>
        </div>
    );
}

export default Index;